import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Button, Dialog, DialogTitle } from "@material-ui/core/";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import RichTextEditor from "react-rte";
import AutomService from "../../../../services/AutomService/AutomService";
import { TextField } from "@material-ui/core";
import { useSetRecoilState} from 'recoil';
import { alertState} from '../../../../recoil-store/recoil-state';

/**
 * @Description this page Upgrade Flow
 * @Param       action - object
 * @Param       flow - autom flow
 * @Param       automDetail - automDetail
 * @Param       setOpen -  close or open modal
 * @Returns     div element
 * @Author      Kerem Karadeniz
 */
const UpgradeFlow = (props) => {
  const { t } = useTranslation();
  const [editorState, setEditorState] = useState(
    RichTextEditor.createEmptyValue()
  );
  const [version, setVersion] = useState("");
  const setAlert = useSetRecoilState(alertState);

  useEffect(() => {
    //get by autom version

    // sorted version
    function compare( a, b ) {
      let versionNumber = Number(a.version.replace(".",""));
      let versionNumberSecond = Number(b.version.replace(".",""));
      if ( versionNumber < versionNumberSecond ){
        return -1;
      }
      if ( versionNumber > versionNumberSecond ){
        return 1;
      }
      return 0;
    }

    let newVer = props.automVersion.sort(compare);
    let upgradedVersion = calculateUpgradeVersion(newVer[newVer.length -1 ].version)
    setVersion(upgradedVersion);
  }, [props.automDetail?.versionId, props.automVersion]);

  // close page
  function handleClose() {
    props.setOpen(false);
  }

  function calculateUpgradeVersion(number) {
    // sample data 2.3.4
    let newNumber = number.split(".");
    let numberFirst = Number(newNumber[0]);
    let numberSecondary = Number(newNumber[1]);
    let numberThird = Number(newNumber[2]);

    if (numberThird + 1 <= 9) {
      numberThird++;
    } else {
      if (numberSecondary + 1 <= 9) {
        numberSecondary++;
      } else {
        numberSecondary = 0;
        numberFirst++;
      }
      numberThird = 0;
    }

    let newUpgradedVersion = numberFirst + "." + numberSecondary + "." + numberThird
    return newUpgradedVersion;
  }

  // upgrade autom flow
  async function handleUpgrade() {
    const upgradeData = {
      flow: props.flow,
      diagram: props.diagram,
      version,
      autom_id: props.automDetail.id,
      description: editorState.toString("html"),
    };
    const response = await AutomService.upgradeAutomFlow(upgradeData);
    if (response) {
      if (response.status) {
        setAlert(alert => ({ ...alert, show: true, message: "Upgraded!", severity: 'success' }))
        props.setLoading(true);
        handleClose();
      } else {
        //TODO : add fail message translate and show
        setAlert(alert => ({ ...alert, show: true, message: "Upgraded Failed!", severity: 'error' }))
        handleClose();
      }
    }
  }

  const handleEdit = (value) => {
    setEditorState(value);
  };
  return (
    <Dialog id="autom-addNew-modal" data-test="autom-add-new" open={true}>
      <DialogTitle
        id="alert-dialog-title"
        style={{ backgroundColor: "#001128" }}
      >
        <div id="about-title">
          <b>Upgrade Flow</b>
          <Button data-test="cancelautom-button" onClick={handleClose}>
            <b>{t("CONTENT.AUTOMS-LIST.CLOSE")}</b>
          </Button>
        </div>
      </DialogTitle>
      <DialogContent>
        <div style={{ textAlign: "left", marginTop: 20 }}>
          <div className="form-element upgrade-flow-element">
            <div>
              <strong>Version</strong>
            </div>
            <TextField
              id="outlined-basic"
              variant="outlined"
              disabled={true}
              value={version}
              onChange={(e) => setVersion(e.target.value)}
            />
          </div>
          <div className="form-element">
            <strong>Description</strong>
            <RichTextEditor
              value={editorState}
              editorClassName="publish-editor"
              onChange={(value) => handleEdit(value)}
            />
          </div>
        </div>
      </DialogContent>
      <DialogActions
        style={{
          justifyContent: "space-between",
          padding: "8px 24px 16px 24px",
        }}
      >
        <Button variant="outlined" color="secondary" onClick={handleClose}>
          Cancel
        </Button>
        <Button variant="outlined" color="primary" onClick={handleUpgrade}>
          Upgrade
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default UpgradeFlow;
